<template>
  <div class="header">
    <BbIcon class="favorites-icon" :name="icon" :type="iconType" size="small" />
    <TextBody
      tag="span"
      :i18n-key="titleKey"
      :text="title"
      weight="medium"
      :body-type="2"
      class-name="ellipsis-1-row"
    />
    <span v-if="count" class="count">{{ '(' + count + ')' }} </span>
    <BbBtn
      class="close-button"
      size="x-small"
      type="icon"
      icon="x-small"
      icon-size="medium"
      no-background
      @click="onClose"
    />
  </div>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';
import useModals from '~/composables/useModals';

export default {
  components: { TextBody },
  props: {
    titleKey: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: '',
    },
    iconType: {
      type: String,
      default: 'filled',
    },
  },
  setup() {
    const { setCurrentDocumentsDialog } = useModals();

    const onClose = () => {
      setCurrentDocumentsDialog(null);
    };

    return { onClose };
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: $bb-spacing-2;
  padding: $bb-spacing-4;
  border-bottom: 1px solid $bb-neutral-5;
  background-color: $bb-neutral-6;

  .favorites-icon {
    background-color: $bb-neutral-1;
    color: $bb-neutral-0;
    padding: 6px;
    border-radius: 50%;
  }

  .count {
    @include bb-regular-text-styles('lg');
    font-weight: 500;
  }

  .close-button {
    margin-left: auto;
  }
}
</style>
